module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('drawer', {
    attrs: {
      "show": _vm.showDrawer,
      "pos": "left",
      "tran": "push"
    },
    on: {
      "change-show": function($event) {
        _vm.showDrawer = arguments[0]
      }
    }
  }, [_c('div', {
    staticClass: "drawercontent",
    slot: "drawer"
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', {
    staticClass: "modal-card-body titredrawerscroll"
  }, [_c('titre-drawer', {
    attrs: {
      "id": _vm.livreId
    }
  })], 1), _c('div', {
    staticClass: "modal-card-foot"
  }, [(_vm.livreEan13) ? _c('router-link', {
    staticClass: "is-primary button",
    attrs: {
      "to": {
        name: 'suggestion',
        params: {
          ean13: _vm.livreEan13
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDrawer($event)
      }
    }
  }, [_vm._v("Faire une recherche à partir de ce livre")]) : _vm._e()], 1)])]), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a1f2b3"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1353
// module chunks = 1